export default "__VITE_ASSET__DwTMU85h__"